module.exports = __webpack_public_path__ + "static/img/5.21dafd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/5.png
// module id = VBfn
// module chunks = 0